export const CameraAccess = {
  CameraPermissionDenied: 'カメラ権限が許可されていません。写真を撮影する場合は、「設定」>「タヨリス」>「カメラ」の権限を許可してください。',
}
